import { Injectable } from '@angular/core';
import { Socket, io } from 'socket.io-client';
import * as env from 'environments/environment';
import { Observable } from 'rxjs';
import { DataCollectorService } from './data_collector.service';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  socket: Socket;

  constructor(
    private dataCollectorService: DataCollectorService
  ) { 
    if(!this.socket){
      this.socket = io(this.dataCollectorService.socketUrl);
    }
  }

  sendMessage(message: string) {
    this.socket.emit('global', message);
  }

  getMessage(): Observable<string> {
    return new Observable<string>(observer => {
      if (this.socket) {
        this.socket.on('global', (data: string) => {
          observer.next(data);
        });
      } else {
        observer.error('Socket is not initialized.');
      }
    });
  }

  joinWorkflowRoom(uid: string): void {
    this.socket.emit('joinRoom', uid);
  }

  leaveWorkflowRoom(uid: string): void {
    this.socket.emit('leaveRoom', uid);
  }

  getRoomMessage(): Observable<any> {
    return new Observable<any>(observer => {
      this.socket.on('roomMessage', (data) => {
        observer.next(data);
        // Handle the room message as needed
      });
    })
  }
  
}
